import styles from './index.css'

type ModalFooterProps = {
  children: JSX.Element | string
}

const ModalFooter = ({ children }: ModalFooterProps): JSX.Element => {
  return <footer className={styles.footer}>{children}</footer>
}

export default ModalFooter
